import { render, staticRenderFns } from "./Challenge3DS.vue?vue&type=template&id=30b70f71"
import script from "./Challenge3DS.vue?vue&type=script&lang=js"
export * from "./Challenge3DS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports